import React, { useState } from "react";
import {
  Box,
  Card,
  Grid,
  IconButton,
  Typography,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const months = [
  "januari",
  "februari",
  "maart",
  "april",
  "mei",
  "juni",
  "juli",
  "augustus",
  "september",
  "oktober",
  "november",
  "december",
];
const daysShort = ["ma", "di", "wo", "do", "vr", "za", "zo"];

const CalendarUI = () => {
  const [baseMonth, setBaseMonth] = useState(dayjs("2025-10-01"));
  const [selectedRange, setSelectedRange] = useState({
    start: dayjs("2025-10-22"),
    end: dayjs("2025-10-24"),
  });
  const navigate=useNavigate()

  // Mock API statuses
  const getDateStatus = (date) => {
    if (!date) return null; // <-- prevent null crash
    const d = date.date();
    if ([13, 14, 15, 17, 18, 19].includes(d)) return "unavailable";
    if ([22, 23, 24].includes(d)) return "selected";
    if (d === 20) return "blocked";
    return "available";
  };

  const handlePrev = () => setBaseMonth(baseMonth.subtract(1, "month"));
  const handleNext = () => setBaseMonth(baseMonth.add(1, "month"));

  const renderMonth = (month) => {
    const startDay = month.startOf("month").day() || 7;
    const daysInMonth = month.daysInMonth();
    const blanks = Array(startDay - 1).fill(null);
    const days = Array.from({ length: daysInMonth }, (_, i) =>
      month.date(i + 1)
    );
    const fullDays = [...blanks, ...days];

    return (
      <Box flex={1} sx={{ minWidth: 320 }}>
        <Typography variant="h6" align="center" mb={1}>
          {months[month.month()]} {month.year()}
        </Typography>
        <Grid container spacing={0.5}>
          {daysShort.map((d) => (
            <Grid item xs={1.7} key={d}>
              <Typography align="center" fontWeight="bold" color="gray">
                {d}
              </Typography>
            </Grid>
          ))}
          {fullDays.map((d, i) => (
            <Grid item xs={1.7} key={i}>
              <Box
                sx={{
                  height: 38,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 1,
                  cursor: d ? "pointer" : "default",
                  bgcolor: !d
                    ? "transparent"
                    : getDateStatus(d) === "available"
                    ? "#2e7d32"
                    : getDateStatus(d) === "unavailable"
                    ? "#f8bbd0"
                    : getDateStatus(d) === "selected"
                    ? "#2196f3"
                    : getDateStatus(d) === "blocked"
                    ? "#d32f2f"
                    : "transparent",
                  color: d ? "white" : "transparent",
                  fontWeight: getDateStatus(d) === "selected" ? "bold" : 500,
                }}
              >
                {d ? d.date() : ""}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  };

  return (
    <Card sx={{ p: 2, borderRadius: 3 }}>
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Select
            size="small"
            value={`${months[baseMonth.month()]} ${baseMonth.year()}`}
            onChange={(e) => {
              const [m, y] = e.target.value.split(" ");
              setBaseMonth(dayjs(`${y}-${months.indexOf(m) + 1}-01`));
            }}
          >
            {months.map((m) => (
              <MenuItem key={m} value={`${m} ${baseMonth.year()}`}>
                {m} {baseMonth.year()}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Button variant="outlined" size="small" color="error">
          Deselecteer
        </Button>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <IconButton onClick={handlePrev}>
          <ArrowBack />
        </IconButton>
        <IconButton onClick={handleNext}>
          <ArrowForward />
        </IconButton>
      </Box>
      {/* Calendar body */}
      <Box display="flex" gap={3}>
        {renderMonth(baseMonth)}
        {renderMonth(baseMonth.add(1, "month"))}
      </Box>

      {/* Footer */}
      <Box
        sx={{
          mt: 3,
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: 2,
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <img
            src="https://picsum.photos/80"
            alt="Boormossel"
            style={{ width: 70, height: 70, borderRadius: 8 }}
          />
          <Box>
            <Typography fontWeight="bold">
              Boormossel 5 personen (hond toegestaan)
            </Typography>
            <Typography variant="body2" color="text.secondary">
              📅 {selectedRange.start.format("DD-MM-YYYY")} →{" "}
              {selectedRange.end.format("DD-MM-YYYY")}
            </Typography>
          </Box>
        </Box>
        <Box textAlign="right">
          <Typography variant="h6" fontWeight="bold">
            € 463,08
          </Typography>
          <Typography variant="body2" color="text.secondary">
            incl. toeslagen
          </Typography>
          <Button
            variant="contained"
            color="success"
            sx={{ mt: 1, borderRadius: 2 }}
            
 onClick={()=>navigate('/bookNowFormHotel')}

          >
            Boek nu
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

export default CalendarUI;
